import { useQuery } from "@tanstack/react-query";

import { getPracticeManagementPlantProtectionEmissionFactors } from "services";

import { PRACTICE_MANAGEMENT, PRACTICE_MANAGEMENT_PLANT_PROTECTION_EMISSION_FACTORS } from "consts";

export const usePracticeManagementPlantProtectionEmissionFactors = (version?: string, country: PracticeManagement.CountryCode = "global") =>
  useQuery({
    queryKey: [PRACTICE_MANAGEMENT, PRACTICE_MANAGEMENT_PLANT_PROTECTION_EMISSION_FACTORS, country, version],
    queryFn: async () => {
      const factors = await getPracticeManagementPlantProtectionEmissionFactors(version, country);
      return factors.map((factor) => ({
        ...factor,
        editingKey: factor.plantProtectionId,
      }));
    },
    staleTime: 1000 * 60 * 60, // 1h
    gcTime: 1000 * 60 * 24,
  });
